import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadFutureCard } from "../lib/shareCard";

export const ShareCardButton = ({ fs, message, years, testId = "share-card-btn", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const y = years || fs.years;
  const futurePath = fs.journey?.aged_photos?.[y];

  const go = async () => {
    setBusy(true);
    try {
      await downloadFutureCard({
        todayUrl: fs.photoUrl,
        futureUrl: futurePath ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${futurePath}` : fs.agedUrl,
        message,
        ageLabel: fs.futureAgeLabel(y),
        name: fs.journey?.character?.name,
      });
      toast.success("Your future card is downloading.");
    } catch {
      toast.error("Couldn't create the card.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={go} disabled={busy || !message} className={`btn-pill text-xs ${className}`} data-testid={testId}>
      {busy ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />} Download future card
    </button>
  );
};
